export default __webpack_public_path__ + "static/media/ust.debb0df2.png";